import { Drawer } from '@/components';
import type { ComponentProps, FC } from 'react';
import { useDrawerState } from '../DrawerStateProvider';
import { MasterTableEditWarning } from '../MasterTableEditWarning';
import { BudgetTypeForm } from './BudgetTypeForm';

type Props = ComponentProps<typeof BudgetTypeForm>;

export const BudgetTypeFormDrawer: FC<Props> = ({
  type,
  initialValues,
  onSubmit,
}) => {
  const { drawerState, setDrawerState } = useDrawerState();

  return (
    <Drawer
      open={drawerState.open && drawerState.type === 'budget-type'}
      onClose={() => {
        setDrawerState({ open: false });
      }}
      destroyOnClose
    >
      {type === 'edit' && <MasterTableEditWarning marginBottom={8} />}
      <BudgetTypeForm
        type={type}
        initialValues={initialValues}
        onSubmit={onSubmit}
      />
    </Drawer>
  );
};
